import { render, staticRenderFns } from "./Adv.vue?vue&type=template&id=1788f1c2"
import script from "./Adv.vue?vue&type=script&lang=js"
export * from "./Adv.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports